import {useEffect, useState} from "react";
import useStatisticsData from "../Statistics/useStatisticsData.js";
import usePollingWhenVisible from "../../hooks/usePollingWhenVisible.js";

const LIVE_URL = "/nutzung/daten/live";
const TAKT_MS = 15000;

/**
 * Wer ist gerade angemeldet - bewusst UNABHÄNGIG vom gewählten Zeitraum-
 * Filter der Nutzungsauswertung, denn "jetzt" kennt kein Von/Bis. Aktualisiert
 * sich alle 15 Sekunden, aber nur solange der Tab sichtbar ist
 * (usePollingWhenVisible - dieselbe Zurückhaltung wie beim Ticket-Poll).
 *
 * Eigener Hook, weil sowohl Pages/Nutzung/Live.jsx als auch der neue
 * Schwerpunkt "Gerade im System" im Überblick denselben Abruf brauchen -
 * Live.jsx bleibt dabei unverändert (eigene, unabhängige Kopie der Logik),
 * dieser Hook bedient ausschließlich den Überblick.
 */
export default function useNutzungLive() {
    const {data: initialData, loading, error} = useStatisticsData(LIVE_URL, {});
    const [live, setLive] = useState(null);
    const [stand, setStand] = useState(null);

    useEffect(() => {
        if (initialData) {
            setLive(initialData);
            setStand(new Date());
        }
    }, [initialData]);

    usePollingWhenVisible(LIVE_URL, TAKT_MS, (frisch) => {
        setLive(frisch);
        setStand(new Date());
    });

    const rows = Array.isArray(live) ? live : [];

    return {rows, loading, error, stand};
}
